import { KEYCLOAK_COOKIE } from "./constants";

const COOKIE_MAX_AGE_SEC = 60 * 5;

export function setAuthCookie(token: string): void {
  if (typeof document === "undefined") return;
  document.cookie = `${KEYCLOAK_COOKIE}=${encodeURIComponent(
    token
  )}; path=/; max-age=${COOKIE_MAX_AGE_SEC}; SameSite=Lax`;
}

export function clearAuthCookie(): void {
  if (typeof document === "undefined") return;
  document.cookie = `${KEYCLOAK_COOKIE}=; path=/; max-age=0`;
}

export function clearAuthCookieHeader(): string {
  return `${KEYCLOAK_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
}

